var pre_orders = {
};


document.addEventListener('variant:change', function(evt) {
  var variant = evt.detail.variant;
  var sectionChange = evt.detail.sectionChange;
  var ending_ship_date = '';
  $('#pre-order--block-'+sectionChange).val("");
  /* Pre-order Check */
  if(variant.sku in pre_orders){
    // if(variant.sku.includes("Blanket")){
    //   ending_ship_date = "; January";
    // } else if(variant.sku.includes("PeriwinklePixieDust")){
    //   ending_ship_date = "; End of January";
    // } else {
    //   ending_ship_date = "; Mid January";
    // }
    if(variant.available != false){
      if(pre_orders[variant.sku] !== ""){
        $('.product--pre-order').show();
        $('.pre-order-status-'+sectionChange).show();        
        $('.ship-date').show();
        $('.product--pre-order').removeClass('inventory--low');
        $('.pre-order-status-'+sectionChange).text(pre_orders[variant.sku] + "" + ending_ship_date);
        $('#pre-order--block-'+sectionChange).val(pre_orders[variant.sku]);
        $('.product__preorder-'+sectionChange).append("<input class=\"pre-order__input-"+sectionChange+"\" type=\"text\" name=\"properties[Pre-Order]\" hidden value=\""+pre_orders[variant.sku]+"\">");
      } else {
        $('.product--pre-order').hide();
      }
    } else {
      $('.product--pre-order').addClass('inventory--low');
      $('.pre-order-status-'+sectionChange).show();
      $('.pre-order-status-'+sectionChange).text("Sold Out");
      $('.ship-date').hide();
      $(".pre-order__input-"+sectionChange).remove();
    }
  } else {
    if(variant.available != false){
      $('.product--pre-order').removeClass('inventory--low');
      $('.product--pre-order').show();
      $('.pre-order-status-'+sectionChange).show();
      $('.pre-order-status-'+sectionChange).text("In Stock, Ready To ship");
      // $('.pre-order-status-'+sectionChange).text("Shipping end of May");
      $(".pre-order__input-"+sectionChange).remove();
      $('.ship-date').hide();
    } else {
      $('.product--pre-order').addClass('inventory--low');
      $('.product--pre-order').show();
      $('.pre-order-status-'+sectionChange).show();
      $('.pre-order-status-'+sectionChange).text("Sold Out");
      $(".pre-order__input-"+sectionChange).remove();
      $('.ship-date').hide();
    }
  }
  /* Pre-order Check End */
});